<template>
  <header>
    <p v-show="titleBefore" class="data-details__cat text-center">{{ titleBefore }}</p>
    <h1 class="data-details__title">{{ title }}</h1>
    <slot name="title-after">
      <p v-show="titleAfter" class="data-details__cat text-center mt-3">{{ titleAfter }}</p>
    </slot>

    <div
      class="image-wrapper"
      :class="{ 'image-wrapper--with-credit': !!imageCreditLine, 'image-wrapper--square': squareImage }"
    >
      <div class="data-details__img mt-4" :class="{ square: squareImage }" :style="`background-image:url(${image})`" />
      <p v-show="imageCreditLine" class="image-credit-line">{{ imageCreditLine }}</p>
    </div>
  </header>
</template>

<script>
export default {
  name: 'EntityPageHeader',
  props: {
    image: {
      type: String,
      default: '',
    },
    imageDetails: {
      type: Object,
      default: null,
    },
    squareImage: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    titleBefore: {
      type: String,
      default: '',
    },
    titleAfter: {
      type: String,
      default: '',
    },
  },
  computed: {
    imageCreditLine() {
      return this.imageDetails ? this.imageDetails.creditLine : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.data-details__title,
.image-credit-line {
  max-width: 840px;
  margin: 0 auto;
  text-align: center;
}

.image-wrapper {
  &--with-credit:not(&--square) {
    margin-bottom: 60px;
  }

  &--with-credit.image-wrapper--square {
    margin-bottom: 16px;
  }

  &--with-credit {
    .data-details__img {
      margin-bottom: 24px;
    }
  }

  .image-credit-line {
    font-style: italic;
    color: vars.$c-gray-a2;
  }
}
</style>
